module.exports = __webpack_public_path__ + "static/media/fern-1.d7f1de67.fbx";